import { fetchCustomer } from 'states/customer/customer.slice';
export function fetchAppData(dispatch: any){
  dispatch(fetchCustomer());
}